import { render, staticRenderFns } from "./InputItems.vue?vue&type=template&id=420f8c9e&"
import script from "./InputItems.vue?vue&type=script&lang=js&"
export * from "./InputItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports